import { render } from "./CheckBold.vue?vue&type=template&id=5603f41f"
import script from "./CheckBold.vue?vue&type=script&lang=js"
export * from "./CheckBold.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__